import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  position: "relative",
}));

export const Label = styled("label")(({ theme }) => ({
  ...theme.mixins.flexAlignCenter,
  fontSize: 12,
  lineHeight: "16px",
}));

export const RadioInput = styled("input")(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: 0,
  zIndex: 2,
  width: "100%",
  height: "100%",
  opacity: 0,
  margin: 0,
  cursor: "pointer",
}));

export const RadioBlock = styled("div")(({ theme, $hasLabel, $checked }) => ({
  "& .radio_icon": {
    fontSize: $hasLabel ? 16 : 20,
    color: $checked ? theme.palette.primary.main : theme.palette.fly.checkboxBorder,
    transition: "all 0.3s ease",
  },
}));
